export { default } from './ModernModal';
export { WrapperIcon } from './ModernModal.styles';
export * from './types';
